const $ = require('jquery');
const _ = require('lodash');
const openCartMapper = require('./atmmapper/open-cart-mapper');

module.exports = function (shopper, $document, shopPageStateService, breakpointsService, loginService, globalHeaderAnalyticsService, globalHeaderPanelService, $state, trolleyService, settingsService, $timeout, categoriesService, featureService, $rootScope, atm, rrPubSub, catalogService, bwsNotificationService, $http, $window) {
    return {
        restrict: 'E',
        template: require('./global-header-template.html').trim(),
        link(scope, element) {
            scope.storePagesRedirectSettings = null;
            scope.enableRedirect = false;
            scope.isHomepageEnabled = featureService.isEnabled(featureService.features.homepageOnSmallFormat);
            scope.shopPageStateService = shopPageStateService;
            scope.state = $state;
            scope.shopper = shopper;
            scope.trolley = trolleyService;
            scope.isUserDropdownVisible = false;
            scope.categories = catalogService.topLevelCategories;
            scope.counter = 0;
            scope.isDropNavEnabled = false;
            scope.isPremixNavEnabled = false;
            scope.isMeganavReadyToRender = false;
            let el = undefined;
            let el2 = undefined;
            scope.isSiftEnabled = false;

            settingsService.getFrontendSetting('StorePages', 'StorePagesRedirect')
				.then((res) => {
                    scope.storePagesRedirectSettings = JSON.parse(res[0].Value);
                    scope.enableRedirect = scope.storePagesRedirectSettings && scope.storePagesRedirectSettings.EnableRedirect;
                });

            scope.redirectStorePage = () => {
                if (scope.storePagesRedirectSettings && scope.storePagesRedirectSettings.EnableRedirect) {
					$window.location.assign(scope.storePagesRedirectSettings.RedirectBaseUrl);
				}
            };

            //Accessibility
            scope.enter = function (e) {
                if (e.keyCode === 13) {
                    scope.isTriggeredByKeyboard = true;
                    scope.selectedTab = e.currentTarget.dataset.value;
                }
            };
            settingsService.getFrontendSetting('Menunav', 'menunavpremix').then((response) => {
                if (response) {
                    scope.isPremixNavEnabled = response[0] ? JSON.parse(response[0].Value) : false;
                    if (scope.isPremixNavEnabled) {
                       scope.categories.find(item => item.Attributes.content_display === 'PremixMenuNavPromotion').Attributes.isEnabled = true;
                    }
                }
            });


            settingsService.getSettingValue('Sift', 'EnableSiftPushEvent').then(function (response) {
                if (response) {
                    scope.isSiftEnabled = response;
                }
            });

            scope.goToDepartment = function (link) {
                $state.go('shop.browse.department', { department: link }, { reload: 'shop.browse.department', notify: true });
            };

            scope.isTouchDevice = angular.element('html.touchevents').length > 0;

            scope.handleDepartmentNavOnClick = function (link, $event, weblink) {
                if (weblink) {
                    $state.go(weblink, {}, { reload: true });
					return;
                }
                if (!($($event.currentTarget).hasClass('nav-main_item') && $($event.target).hasClass('tab-link'))) {
                    return;
                }

                if (scope.counter === 2) {
                    scope.counter = 0;
                }

                if (scope.counter === 1) {
                    el2 = $event.currentTarget;
                }

                if (scope.counter === 0) {
                    el = $event.currentTarget;
                }

                scope.counter++;

                if (!scope.isTouchDevice) {
                    scope.goToDepartment(link);
                    scope.counter = 0;
                } else if (scope.isTouchDevice && el === el2) {
                    scope.goToDepartment(link);
                    scope.counter = 0;
                }
            };

            scope.openLeftPanel = function () {
                shopPageStateService.triggerPanel('left', true);
            };

            settingsService.getSettingValue('VisualShopping', 'GlobalHeaderWappleImage')
                .then(function (path) {
                    scope.GlobalHeaderWappleImagePath = path;
                });

            settingsService.getSettingValue('VisualShopping', 'SearchWappleImage')
                .then(function (path) {
                    scope.SearchWappleImagePath = { 'background-image': 'url("${path}")' };
                    scope.SmallFormatWapplePath = path;
                });

            scope.trolleyCount = function () {
                return _.sumBy(trolleyService.trolleyProducts, 'Quantity') +
                       _.sumBy(trolleyService.unavailableProducts, 'Quantity') +
                       _.sumBy(trolleyService.partiallyUnavailableProducts, 'Quantity');
            };

            //scope.defaultSpecialGroup = 'shop.specials.browse';
            (function initDefaultLeftPanel() {
                // Get the default panel to display
                settingsService.getSettingValue('OneSite', 'DefaultPageToSpecialGroup')
                    .then(function (result) {
                        scope.defaultSpecialGroup = $state.href(result && result.toLowerCase() === 'true' ? 'shop.specials.groups' : 'shop.specials.browse');
                    });

                settingsService.getSettingValue('OneSite', 'ReturnSpaceToDefaultStateEnabled').then(function (enabled) {
                    scope.returnSpaceToDefaultState = enabled;
                });

            })();

            scope.toggleUserDropdown = function () {
                return !scope.isUserDropdownVisible
                    ? scope.showUserDropdown()
                    : scope.hideUserDropdown();
            };

            scope.showUserDropdown = function () {
                scope.isUserDropdownVisible = true;

                // we attach the body handler in a setTimeout rather than
                // $timeout because we don't need to trigger another digest cycle.
                setTimeout(function () {
                    $('body').one('click.userDropdownHide', function () {
                        scope.$apply(function () {
                            scope.isUserDropdownVisible = false;
                        });
                    });
                });
            };

            scope.logout = function () {
                if (scope.isSiftEnabled) {
                $http.get(`${$window.config.apiUrl}/Bootstrap`)
                    .then((result) => {
                        const sessionId = JSON.stringify(result.data.data['/Settings/PageModel'].Context.ContextId);
                        window._sift.push(['_setUserId', '']);
                        window._sift.push(['_setSessionId', sessionId]);
                    }).catch((e) => {
                        console.log('Error: ', e);
                    }).finally(() => {
                        loginService.logout();
                    });
                } else {
                    loginService.logout();
                }
            };

            scope.favouritesLoginAlert = function () {
                if (shopper.currentUser.isGuest) {
                    $timeout(function () {
                        bwsNotificationService.info('You need to login or register to add to your favourites');
                    }, 1000);
                }
             };

            scope.isSmallFormat = breakpointsService.isSmallFormat();
            scope.breakpointsService = breakpointsService;

            scope.$on('window:resize', function () {
                scope.$apply(function () {
                    scope.isSmallFormat = breakpointsService.isSmallFormat();
                });
            });

            scope.toggleCollectionZone = function (isLargeFormat) {
                if (isLargeFormat) {
                    shopPageStateService.triggerPanel('right');
                } else {
                    shopPageStateService.triggerPanel(shopPageStateService.panels.right ? 'left' : 'right');
                }
            };

            scope.hideUserDropdown = function () {
                scope.isUserDropdownVisible = false;

                $('body').off('click.userDropdownHide');
            };

            scope.showMenu = function () {
                shopPageStateService.smallFormatMenuOpen = !shopPageStateService.smallFormatMenuOpen;
            };

            scope.$on('special-view-change', function (evt, arg) {
                scope.specialsViewType = arg;
            });

            scope.isTmoPanelOpen = function () {
                return globalHeaderPanelService.isOpen(globalHeaderPanelService.panels.trackmyorder);
            };

            scope.toggleTmoPanel = function () {
                return globalHeaderPanelService.togglePanel(globalHeaderPanelService.panels.trackmyorder);
            };

            scope.togglePanel = function () {
                shopPageStateService.togglePanel('right');
                //Fire the view cart events only when opening the panel
                if (shopPageStateService.panels.right === true) {
                    atm.push(scope.trolley, openCartMapper, false, 'header');
                    rrPubSub.publish(rrPubSub.EVENTS.CART_PAGE, { items: _.map(trolleyService.trolleyProducts, 'Stockcode') });
                }
            };

            scope.isSignupPanelOpen = function () {
                return globalHeaderPanelService.isOpen(globalHeaderPanelService.panels.signup);
            };

            scope.isLoginPanelOpen = function () {
                return globalHeaderPanelService.isOpen(globalHeaderPanelService.panels.login);
            };

            scope.trackMyOrder = function () {
                if (shopper.currentUser.isGuest) {
                    scope.toggleTmoPanel();
                } else {
                    $state.go('shop.myaccount.trackmyorder');
                }
            };

            scope.isGuestAccessToListsEnabled = function () {
                return featureService.isEnabled(featureService.features.enableGuestAccessToLists) && shopper.currentUser.isGuest;
            };

            scope.isMyListState = function () {
                return $state.includes('shop.list') || $state.includes('shop.guestList');
            };

            scope.$on('$stateChangeStart', function () {
              element.find('.js-event-header').addClass('menu-closed').delay(2000).queue(function () {
                    angular.element(this).removeClass('menu-closed').dequeue();
                });
            });

            scope.$on('$stateChangeSuccess', () => {
                shopPageStateService.triggerPanel('right', false);
            });

            settingsService.getFrontendSetting('MenuNav', 'IsAemMegaNavEnabled')
                .then((res) => {
                    if (res && res[0] && res[0].Value === 'true') {
                        scope.isAemMegaNavEnabled = true;
                    }
                    scope.isMeganavReadyToRender = true;
                }).catch(() => {
                    scope.isMeganavReadyToRender = true;
                });
        }
    };
};



/** WEBPACK FOOTER **
 ** ./wowapp/src/shop/components/globalheader/global-header-directive.js
 **/